import React from 'react';
import { red500 } from 'material-ui/styles/colors';
import humanize from 'humanize-string';

const Error = ({ value, index }) => {
    if (!value) {
        return <span />;
    }
    const indexText = typeof index !== 'undefined' ? Number(index + 1) + '. ' : '';
    if (typeof value === 'string') {
        return <small style={{ color: red500 }}>{indexText}{value}</small>;
    }
    const { errmsg } = value;
    if (typeof errmsg === 'string') {
        return <p style={{ color: red500 }}>{errmsg}</p>;
    }
    if (Array.isArray(value)) {
        return (
            <div>
                {value.map((obj, index) => {
                    return <Error key={index} value={obj} index={index} />;
                })}
            </div>
        );
    }
    if (typeof value === 'object') {
        const errors = Object.keys(value).reduce((acc, cur) => {
            if (typeof value[cur] === 'string') {
                const errorKeyText = cur !== '_error'
                    ? humanize(cur) + ': '
                    : '';
                const elem = (
                    <div>
                        <small style={{ color: red500 }} key={cur}>
                            {indexText}
                            {errorKeyText}
                            {value[cur]}
                        </small>
                    </div>
                );
                acc.push(elem);
            } else {
                acc.push(<Error value={value[cur]} index={index} />);
            }
            return acc;
        }, []);
        return <div>{errors.map((el, index) => React.cloneElement(el, { key: index }))}</div>;
    }
    return <span />;
};

export default Error;



/** WEBPACK FOOTER **
 ** ../src/dash/front/campaign/components/Form/Error.js
 **/